module.exports = __webpack_public_path__ + "media/Video 156b.275b31a3.mp4";